<div
  class="line-numbers"
  [ngClass]="{ 'cw-markdown-custom-style': applyCustomStyle }"
>
  <div [innerHTML]="rawHtml"></div>
</div>
